/** The paths and polygons of a logo taken from its SVG file, for logos drawn inline in a CSS color */
export function LogoShapes({
  shapes,
}: {
  shapes: ReadonlyArray<{ type: "path" | "polygon"; value: string }>;
}) {
  return (
    <>
      {shapes.map((shape) =>
        shape.type === "path" ? (
          <path key={shape.value} d={shape.value} />
        ) : (
          <polygon key={shape.value} points={shape.value} />
        )
      )}
    </>
  );
}
